module.exports = __webpack_public_path__ + "img/session_complete@2x.a9d6087f.png";